<template>
  <section class="vendors">
    <div class="container">
      <div
        class="d-flex justify-content-center mb-4 mt-3"
        v-if="auth.iframeSrc"
      >
        <button @click="goToReferrals()" class="btn btn-outline-dark mr-3">
          <i class="fas fa-envelope-open-text"></i> Referrals
        </button>
        <button @click="goToMap()" class="btn btn-outline-primary mr-3">
          <i class="fas fa-map-marked-alt"></i> Vendors Map
        </button>
        <button @click="doLogout()" class="btn btn-outline-danger">
          <i class="fas fa-sign-out-alt"></i> Logout
        </button>
      </div>
      <div class="row m-0 vendors-container">
        <div class="col">
          <loading v-if="loading" class="shadow-card white-bg" />
          <div v-if="!loading">
            <div class="row vendors-container-main-row">
              <div class="col">
                <div class="row vendor-info-row">
                  <div class="col vendor-logo-col">
                    <img :src="logo" class="rounded-circle w-100" />
                  </div>
                  <div class="col-12 col-md-10">
                    <h6 class="header-pretitle">Vendor</h6>
                    <h1 class="header-title bold text-capitalize">
                      {{ vendor.name }}
                    </h1>
                    <p class="text-dark mt-2 bio-text">
                      <icon class="mr-3" type="align-left" />
                      {{ vendor.bio }}
                    </p>
                    <div class="vendor-links-container flex-wrap">
                      <a
                        class="mr-3"
                        :href="
                          vendor.site.indexOf('http') > -1
                            ? vendor.site
                            : `https://${vendor.site}`
                        "
                        target="_blank"
                        v-if="vendor.site"
                      >
                        <icon class="mr-1" type="globe" />
                        {{ vendor.site }}
                      </a>
                      <a
                        :href="`mailto:${vendor.email}`"
                        class="mr-3"
                        v-if="vendor.email"
                      >
                        <icon class="mr-1" type="envelope" />
                        {{ vendor.email }}
                      </a>
                      <a
                        class="mr-3"
                        :href="vendor.intakeFormInfo"
                        target="_blank"
                        v-if="vendor.intakeFormInfo"
                      >
                        <icon class="mr-1" type="file-download" />
                        Download Intake Form
                      </a>
                      <div class="w-100">
                        <button
                          class="btn btn-sm btn-primary mt-2"
                          @click="viewVendorServices"
                        >
                          ({{ vendor.name }}) Services/Specialties
                        </button>
                        <button
                          class="btn btn-sm btn-secondary mt-2 ml-2"
                          v-if="vendor && vendor.booking_link"
                          @click="openBooking(vendor.booking_link)"
                        >
                          Book an Appointment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4" v-if="vendor.media">
                  <div
                    v-for="m in vendor.media"
                    :key="m.id"
                    class="col-4 col-sm-3 col-md-2"
                  >
                    <img
                      :src="m.thumb"
                      class="w-100 rounded border lift cursor-pointer"
                      @click="enlargeMedia(m)"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-12 col-md-3 p-0 rounded border vendor-map-container"
                style="height: 220px"
              >
                <map-box
                  v-if="location"
                  :default-zoom="10"
                  style="height: 200px"
                  :lat="location.lat"
                  :lng="location.lng"
                  :markers="markers"
                />
                <div class="relative-position">
                  <button
                    class="btn btn-secondary btn-block custom-rounded"
                    @click="getDirections()"
                    v-click-outside="hideDropdownList"
                  >
                    Get Directions
                  </button>
                  <ul
                    v-if="getDirectionsClicked"
                    class="list-group directions-list card shadow-card"
                  >
                    <li
                      :key="index"
                      v-for="(item, index) in vendor.locations"
                      class="list-group-item bg-white rounded-0 cursor-pointer list_item"
                      @click="getDirectionsFor(item)"
                    >
                      {{ getAddress(item) }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <create-order :vendor="vendor" v-if="vendor" />
          </div>
        </div>
      </div>
    </div>
    <modal id="vendor-services-modal">
      <div class="row vendor-info-row" v-if="vendor">
        <div class="col-12">
          <h1 class="header-title bold text-capitalize">
            {{ vendor.name }}
          </h1>
        </div>
        <div
          class="border-top w-100 mt-4 pt-4"
          v-if="vendor.services && vendor.services.length"
        >
          <h3 class="mb-0 ml-2">Services/Specialties</h3>
          <div class="card mt-3">
            <ul class="service-items d-flex flex-wrap p-3">
              <li
                class="service-item col-12 col-sm-6 col-md-4 d-flex align-items-center justify-content-center"
                v-for="service in vendor.services"
                :key="service.id"
              >
                <div
                  class="service-item-container text-center d-flex w-100 align-items-center justify-content-center"
                >
                  {{ service.name }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="text-center">
          No services attached to this vendor yet.
        </div>
      </div>
    </modal>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { default as MapBox } from "../../components/Map";
import { default as CreateOrder } from "../orders/Create";
import Swal from "sweetalert2";
export default {
  name: "VendorPage",
  components: {
    MapBox,
    CreateOrder,
  },
  data() {
    return {
      getDirectionsClicked: false,
      loading: true,
    };
  },
  computed: {
    ...mapState(["saving", "vendors", "modal", "auth"]),
    vendor: function () {
      return this.vendors.single;
    },
    location: function () {
      if (
        this.vendor &&
        this.vendor &&
        this.vendor.locations &&
        this.vendor.locations.length > 0
      ) {
        return {
          lat: this.vendor.locations[0].lat,
          lng: this.vendor.locations[0].lng,
        };
      }

      return null;
    },
    markers: function () {
      if (
        this.vendor &&
        this.vendor.locations &&
        this.vendor.locations.length > 0
      ) {
        return [
          {
            lat: this.vendor.locations[0].lat,
            lng: this.vendor.locations[0].lng,
          },
        ];
      }
      return [];
    },
    logo: function () {
      if (this.vendor && this.vendor.logo) {
        return this.vendor.logoUrl;
      }
      return `/images/logo-gfx.png`;
    },
  },
  mounted() {
    this.loading = true;
    this.getVender(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      doLogout: "auth/logout",
    }),
    getVender: function (id) {
      this.$store.dispatch("vendors/get", { id, forConnect: true }).then(() => {
        this.loading = false;
      });
    },
    enlargeMedia: function (media) {
      Swal.fire({
        imageUrl: media.url,
      });
    },
    viewVendorServices: function () {
      this.$store.dispatch("showModal", "vendor-services-modal");
    },
    goToMap: function () {
      this.$router.push({ path: "/" });
    },
    goToReferrals: function () {
      this.$router.push({ path: "/orders" });
    },
    getDirections: function () {
      this.getDirectionsClicked = !this.getDirectionsClicked;
    },
    getDirectionsFor: function (address) {
      navigator.geolocation.getCurrentPosition((position) => {
        const routeURL = `https://www.google.com/maps/dir/${position.coords.latitude},${position.coords.longitude}/${address.lat},${address.lng}`;
        window.open(routeURL, { target: "_blank" });
      });
      this.getDirections();
    },
    getAddress: function ({ street, city, state, zip, country }) {
      let address = "";
      if ((street || "").trim()) {
        address = `${address}${street}, `;
      }
      if ((city || "").trim()) {
        address = `${address}${city}, `;
      }
      if ((state || "").trim()) {
        address = `${address}${state} `;
      }
      if ((zip || "").trim()) {
        address = `${address}${zip}, `;
      }
      if ((country || "").trim()) {
        address = `${address}${country}`;
      }
      return address;
    },
    hideDropdownList: function () {
      this.getDirectionsClicked = false;
    },
    openBooking: function (link) {
      if (link.indexOf("http") > -1) {
        window.open(link, "_blank");
      } else {
        window.open(`https://${link}`, "_blank");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-rounded {
  border-radius: 0 0 4px 4px;
}

.directions-list {
  max-height: 200px;
  position: absolute;
  width: 100%;
  overflow-y: auto;
}

.service-item {
  padding: 3px;
}
.service-item-container {
  height: 100%;
  background-color: #5c6bc0;
  color: #fff;
  border-radius: 4px;
  padding: 7px;
  font-size: 0.85em;
}
.list_item {
  transition: 0.3s ease-in-out;
  &:hover {
    background-color: #ddd !important;
  }
}
@media (max-width: 767px) {
  .vendors-container {
    .header-pretitle {
      margin-top: 16px;
    }
    .vendors-container-main-row,
    .vendor-info-row {
      flex-direction: column;
      .vendor-logo-col {
        max-width: 200px;
        margin: 0 auto;
      }
      .bio-text {
        text-align: justify;
      }
      .vendor-links-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        a {
          display: flex;
          align-items: center;
        }
      }
    }
    .vendor-map-container {
      margin-top: 24px;
      margin-bottom: 24px;
    }
  }
}
</style>
